import { Between } from "meitav-uikit";
import React from "react";
import { isMobile } from "react-device-detect";

const Chart = ({ riskLevel, riskLevelFirstName, riskLevelEndName }) => (
  <Between>
    <div
      className="scalaMobile"
    
    >
      <p
        style={{
          width: `${isMobile ? "50%" : "auto"}`,
          fontWeight: "bold",
          position: `${isMobile ? "relative" : "inherit"}`,
          top: `${isMobile ? "-15px" : "0"}`,
        }}
      >
        {riskLevelFirstName}
      </p>
    </div>
    <div
      className={`scalaMobile ms-1 me-1 scala1 ${
        riskLevel === 1 ? "scala1shadow" : ""
      }`}
    ></div>
    <div
      className={`scalaMobile ms-1 me-1 scala2 ${
        riskLevel === 2 ? "scala2shadow" : ""
      }`}
    ></div>
    <div
      className={`scalaMobile ms-1 me-1 scala3 ${
        riskLevel === 3 ? "scala3shadow" : ""
      }`}
    ></div>
    <div
      className={`scalaMobile ms-1 me-1 scala4 ${
        riskLevel === 4 ? "scala4shadow" : ""
      }`}
    ></div>
    <div
      className={`scalaMobile ms-1 me-1 scala5 ${
        riskLevel === 5 ? "scala5shadow" : ""
      }`}
    ></div>

    <div
      className="scalaMobile"
      style={{ textAlign: "left", width: `${isMobile ? "50%" : "auto"}` }}
      // className={`${
      //   isMobile ? "scalaRiskLevelMobile col-xs-1" : "col-md-1"
      // } scalaRiskLevel  p-0 text-end me-3`}
    >
      <p
        style={{
          fontWeight: "bold",
          textAlign: "left",
          position: `${isMobile ? "relative" : "inherit"}`,
          top: `${isMobile ? "-15px" : "0"}`,
        }}
      >
        {riskLevelEndName}
      </p>
    </div>
  </Between>

  // <div
  //   style={{ display: "flex", justifyContent: "space-between" }}
  //   className="pt-4 pb-4"
  // >
  //   <div className={`${isMobile ? "scalaRiskLevelMobile" : "scalaRiskLevel"} `}>
  //     {riskLevelFirstName}
  //   </div>
  //   <div
  //     style={{ flexGrow: 1 }}
  //     className={`${riskLevel ==== 1 ? "scala1shadow posRel" : ""} m-1  scala1`}
  //   />
  //   <div
  //     style={{ flexGrow: 1 }}
  //     className={`${riskLevel ==== 2 ? "scala2shadow posRel" : ""} m-1  scala2`}
  //   />
  //   <div
  //     style={{ flexGrow: 1 }}
  //     className={`${riskLevel ==== 3 ? "scala3shadow posRel" : ""} m-1 scala3`}
  //   />
  //   <div
  //     style={{ flexGrow: 1 }}
  //     className={`${riskLevel ==== 4 ? "scala4shadow posRel" : ""} m-1 scala4 `}
  //   />
  //   <div
  //     style={{ flexGrow: 1 }}
  //     className={`${riskLevel ==== 5 ? "scala5shadow posRel" : ""} m-1 scala5 `}
  //   />

  //   <div
  //     className={`${isMobile ? "scalaRiskLevelMobile" : "scalaRiskLevel"}   `}
  //   >
  //     {riskLevelEndName}
  //   </div>
  // </div>
);

export default Chart;
